import { Component, OnDestroy, OnInit } from '@angular/core';
import { DeveloperService } from '../../../../../services/developer/developer.service';
import { DeveloperHardwareConfig } from '../../../../../store/settings/DeveloperHardwareConfig';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-developer-sidebar',
	templateUrl: './developer-sidebar.component.html',
	styleUrls: ['./developer-sidebar.component.scss'],
})
export class DeveloperSidebarComponent implements OnInit, OnDestroy {

	public hardwareConfig: DeveloperHardwareConfig;

	private subscription = new Subscription();

	constructor(
		private developerService: DeveloperService,
	) {

	}

	ngOnInit(): void {
		this.subscription.add(this.developerService.hardwareConfig$.subscribe(config => {
			this.hardwareConfig = config;
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	changeSetting(): void {
		this.developerService.changeSettings(this.hardwareConfig);
	}
}
